// extracted by mini-css-extract-plugin
export default {"card":"WhiteLabelCard_card__XWSwW","fill":"WhiteLabelCard_fill__sDfQQ"};